import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

// Pages (lazy load を推奨)
const DocumentGeneratePage = lazy(() => import('@/pages/document-generate'));
const DocumentResultPage = lazy(() => import('@/pages/document-result'));
const DocumentHistoryPage = lazy(() => import('@/pages/document-history'));
const OrganizationSettingsPage = lazy(
  () => import('@/pages/organization-settings')
);
const NotFoundPage = lazy(() => import('@/pages/not-found'));

// Widgets (AppLayout はここで import)
// import { PrivateRoute } from '@/shared/lib/routing'; // ★ 修正: 旧パスをコメントアウトまたは削除
import { LoadingOverlay } from '@/shared/ui/loading-overlay'; // もしくは簡易的なスピナー
import { AppLayout } from '@/widgets/app-layout';
// ★ 共有の Loading コンポーネント (Suspense fallback 用)

import PrivateRoute from './PrivateRoute'; // ★ 修正: 新しい相対パスからインポート

export const AppRouting: React.FC = () => {
  // Suspense の fallback は中央表示のスピナーなどが望ましい
  const fallback = (
    <LoadingOverlay
      visible={true}
      withOverlay={false}
      message="ページを読み込み中..."
    />
  );

  return (
    <Routes>
      <Route
        path="/settings"
        element={
          <PrivateRoute>
            <Suspense fallback={fallback}>
              <OrganizationSettingsPage />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/"
        element={
          <PrivateRoute>
            {/* AppLayout は認証後に表示される共通レイアウト */}
            <AppLayout />
          </PrivateRoute>
        }
      >
        <Route
          index
          element={
            <Suspense fallback={fallback}>
              <DocumentGeneratePage />
            </Suspense>
          }
        />
        <Route
          path="result/:docId"
          element={
            <Suspense fallback={fallback}>
              <DocumentResultPage />
            </Suspense>
          }
        />
        <Route
          path="history"
          element={
            <Suspense fallback={fallback}>
              <DocumentHistoryPage />
            </Suspense>
          }
        />
      </Route>

      <Route
        path="*"
        element={
          <Suspense fallback={fallback}>
            <NotFoundPage />
          </Suspense>
        }
      />
    </Routes>
  );
};
